<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddNewUser-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddNewUser-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlns:v="https://vecta.io/nano"><path d="M350.2 497.2H161.8c-16.6 0-30-13.4-30-30V86.5c0-16.6 13.4-30 30-30h188.5c16.6 0 30 13.4 30 30v380.7c-.1 16.5-13.5 30-30.1 30z" opacity=".1" fill="#2626bc" enable-background="new"/><path d="M350.2 473.2H161.8c-16.6 0-30-13.4-30-30V62.5c0-16.6 13.4-30 30-30h188.5c16.6 0 30 13.4 30 30v380.7c-.1 16.5-13.5 30-30.1 30z" fill="#6583fe"/><path d="M131.8,75.4h248.5v354.9H131.8V75.4z" fill="#fff"/><path d="M350.2 478.2H161.8c-19.3 0-35-15.7-35-35V62.5c0-19.3 15.7-35 35-35h188.5c19.3 0 35 15.7 35 35v380.7c-.1 19.3-15.8 35-35.1 35h0zM161.8 37.5c-13.8 0-25 11.2-25 25v380.7c0 13.8 11.2 25 25 25h188.5c13.8 0 25-11.2 25-25V62.5c0-13.8-11.2-25-25-25H161.8z" fill="#2626bc"/><g fill="#b7c5ff"><path d="M273.5,59.9h-35c-2.8,0-5-2.2-5-5s2.2-5,5-5h35c2.8,0,5,2.2,5,5S276.2,59.9,273.5,59.9z"/><circle cx="296.8" cy="54.9" r="5"/></g><path d="M351.5 109.3v84.9c0 5.5-4.5 10-10 10H170.6c-5.5 0-10-4.5-10-10v-84.9c0-5.5 4.5-10 10-10h170.9c5.5 0 10 4.4 10 10z" fill="#9fb0fe"/><path d="M351.5 128.3v65.9c0 5.5-4.5 10-10 10H219.6c-.4-3.1-.6-6.3-.6-9.6 0-45.7 37.1-82.8 82.8-82.8 18.6 0 35.8 6.1 49.7 16.5z" fill="#8399fe"/><path d="M351.5 390.6v39.7H160.6v-39.7c0-5.5 4.5-10 10-10h170.9c5.5 0 10 4.4 10 10z" fill="#02ffb3"/><path d="M239.1 405.4c0 8.9-2.1 17.4-5.9 24.8h-72.6v-39.7c0-5.5 4.5-10 10-10h62.6c3.7 7.5 5.9 16 5.9 24.9z" fill="#97ffd2"/><use xlink:href="#B" fill="#ff7eb8"/><use xlink:href="#B" x="102.1" fill="#02ffb3"/><use xlink:href="#C" fill="#8399fe"/><use xlink:href="#C" x="102.1" fill="#ffc4df"/><path d="M251.7 158H186a5 5 0 1 0 0 10h65.7a4.95 4.95 0 0 0 5-5c0-2.8-2.3-5-5-5zm0-19.4H186a5 5 0 1 0 0 10h65.7a4.95 4.95 0 0 0 5-5c0-2.8-2.3-5-5-5z" fill="#fff"/><path d="M197.7 115.2H186a4.95 4.95 0 1 0 0 10h11.7a4.95 4.95 0 0 0 5-5c0-2.8-2.3-5-5-5z" fill="#ffc4df"/><path d="M207.2 360.1h-41.7a4.95 4.95 0 1 0 0 10h41.7a4.95 4.95 0 1 0 0-10z" fill="#8399fe"/><path d="M351.5 390.6v24.6c-19 0-34.3-15.4-34.3-34.3v-.3h24.3c5.5 0 10 4.4 10 10z" fill="#01eca5"/><defs ><path id="B" d="M244.3 277.5h-78.7a4.95 4.95 0 0 1-5-5v-39.7a4.95 4.95 0 0 1 5-5h78.7a4.95 4.95 0 0 1 5 5v39.7a4.95 4.95 0 0 1-5 5z"/><path id="C" d="M244.3 338.9h-78.7a4.95 4.95 0 0 1-5-5v-39.7a4.95 4.95 0 0 1 5-5h78.7a4.95 4.95 0 0 1 5 5v39.7a4.95 4.95 0 0 1-5 5h0z"/></defs></svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.AddNewUser_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.AddNewUser_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="AddNewUser-wrapper-inputs lxn-margin-auto lxn-border-round">
      <div class="AddNewUser-input-spacer">
      </div>
      <customInput v-model="mobile" @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" :placeHolder="$store.getters.language.texts.AddNewUser_placeHolder" inputType="tel">
      </customInput>
      <div class="AddNewUser-input-spacer">
      </div>
      <customInput v-model="name" @focus="input2State='active'" @blur="input2State=''" :inputState="input2State" :placeHolder="$store.getters.language.texts.AddNewUser_placeHolder2" inputType="text">
      </customInput>
    </div>
    <div class="AddNewUser-button lxn-margin-auto lxn-w100">
      <CustomButton @click="addNewUser" bgColor="#1EA5DE" iconRight="verySecure" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.AddNewUser_button}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomInput from '@/components/CustomInput.vue'
import md5 from 'md5'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'AddNewUser',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton,
    CustomInput
  },
  data: function () {
    return {
      hub: this.$store.getters.getHubByUUID(this.$route.params.hubUUID),
      mobile: '',
      name: '',
      input1State: '',
      input2State: ''
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    addNewUser: function () {
      this.input1State = '';
      this.input2State = '';
      if(this.mobile == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddNewUser_alert1);
      }else if(this.name == ''){
        this.input2State = 'error';
        alert(this.$store.getters.language.texts.AddNewUser_alert2);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.dispatch('saveDatabase', this.hub.uuid)
        .then( () => {
          this.$store.dispatch('getUserUuidFromMobile', this.mobile).then(response => {
            if(response.data.status == 'success'){
              var userUUID = response.data.user_uuid;
              if(this.$store.getters.getUserByUUID(this.hub.index, userUUID) != -1){
                alert(this.$store.getters.language.texts.AddNewUser_alert3);
                this.input1State = 'error';
                this.$store.commit('setAppBusy', false);
              }else{
                var uuids = [];
                for(var i = 0; i < this.hub.users.length; i++){
                  if(this.hub.users[i] != this.$store.state.user.uuid){
                    uuids.push(this.hub.users[i].uuid);
                  }
                }
                uuids.push(userUUID);
                this.$store.dispatch('grantSnapshotAccess', {
                  userUUID: this.$store.state.user.uuid,
                  token: this.$store.state.user.loginToken,
                  hubUUID: this.hub.uuid,
                  uuids: uuids,
                })
                .then(response => {
                  if(response.data.status == 'success'){
                    var messagingHook = new Messaging(new Logger(false));
                    var generatedPassword = Math.floor(Math.random()*90000) + 10000;
                    generatedPassword = generatedPassword.toString();
                    messagingHook.init({
                      psk: this.hub.psk,
                      destinationUUID: this.hub.uuid,
                      sourceUUID: this.$store.state.user.uuid
                    });
                    this.$store.dispatch('addUserToHub', {
                      messagingHook: messagingHook,
                      hubUUID: this.hub.uuid,
                      bodyContent: {
                        newUserUUID: userUUID,
                        password: md5(generatedPassword),
                        isOwner: false,
                      }
                    })
                    .then( () => {
                      this.$store.commit('addNewUserToHub', {hubIndex: this.hub.index, uuid: userUUID,name: this.name, isOwner: false,mobile: this.mobile});
                      this.$store.commit('saveState');
                      this.$store.dispatch('saveDatabase', this.hub.uuid)
                      .finally( () => {
                        this.$router.push('/newUserCredentials/' + this.hub.uuid + '/' + generatedPassword);
                        this.$store.commit('setAppBusy', false);
                      })
                    })
                    .catch( response => {
                      if(response.rejectCode == 2){
                        this.$store.commit('setHubStatus', {
                          hubIndex: response.hubIndex,
                          connectionStatus: {
                            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                          },
                        });
                      }
                      this.$router.push('/SettingsHubError');
                      this.$store.commit('setAppBusy', false);
                    });
                  }else{
                    alert(this.$store.getters.language.texts.AddNewUser_serverResponseFail);
                    this.$store.commit('setAppBusy', false);
                  }
                })
                .catch(() => {
                  alert(this.$store.getters.language.texts.Common_internetError);
                  this.$store.commit('setAppBusy', false);
                });
              }
            }else{
              alert(this.$store.getters.language.texts.AddNewUser_serverResponseFail);
              this.$store.commit('setAppBusy', false);
            }
          })
          .catch(() => {
            alert(this.$store.getters.language.texts.Common_internetError);
            this.$store.commit('setAppBusy', false);
          })
        })
        .catch( response => {
          if(response.errorCode == 1){
            alert(this.$store.getters.language.texts.AddNewUser_serverResponseFail);
            this.$store.commit('setAppBusy', false);
          }else if(response.errorCode == 2){
            alert(this.$store.getters.language.texts.Common_internetError);
            this.$store.commit('setAppBusy', false);
          }
        });
      }
    }
  }
}
</script>

<style>
  .AddNewUser-topCurve-wrapper {
    height: 200px;
  }
  .AddNewUser-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .AddNewUser-wrapper-inputs {
    width: calc(100% - 36px);
    height: 148px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .AddNewUser-input-spacer {
    height: 16px;
  }
  .AddNewUser-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.AddNewUser-st0 {
    fill: #ECECEC;
  }
	.AddNewUser-st1 {
    fill: #53636C;
  }
	.AddNewUser-st2 {
    fill: #1EA5DE;
  }
</style>
